module.exports = __webpack_public_path__ + "img/qr.0489acb9.png";